"use client";

import { useState } from "react";
import Image from "next/image";

type Props = {
  urls: string[];
  alt: string;
};

export function PieceGallery({ urls, alt }: Props) {
  const [index, setIndex] = useState(0);

  if (urls.length === 0) {
    return (
      <div className="flex h-full items-center justify-center text-slate-400">
        Image coming soon
      </div>
    );
  }

  const active = urls[Math.min(index, urls.length - 1)];
  const hasMultiple = urls.length > 1;

  return (
    <div className="flex h-full flex-col">
      <div className="relative flex-1">
        <Image
          src={active}
          alt={alt}
          fill
          className="object-contain"
          sizes="(max-width: 768px) 90vw, 720px"
          priority
        />
        {hasMultiple && (
          <>
            <button
              type="button"
              onClick={() => setIndex((i) => (i - 1 + urls.length) % urls.length)}
              className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 text-slate-700 shadow transition hover:bg-white"
              aria-label="Previous photo"
            >
              <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
            <button
              type="button"
              onClick={() => setIndex((i) => (i + 1) % urls.length)}
              className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 text-slate-700 shadow transition hover:bg-white"
              aria-label="Next photo"
            >
              <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </>
        )}
      </div>

      {hasMultiple && (
        <div className="mt-3 flex justify-center gap-2 overflow-x-auto px-2">
          {urls.map((url, i) => (
            <button
              key={url}
              type="button"
              onClick={() => setIndex(i)}
              className={`relative h-14 w-14 flex-shrink-0 overflow-hidden border transition ${
                i === index
                  ? "border-slate-900"
                  : "border-slate-200 opacity-70 hover:opacity-100"
              }`}
              aria-label={`View photo ${i + 1}`}
            >
              <Image src={url} alt="" fill className="object-cover" sizes="56px" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
